import styled from 'styled-components';
export const HeaderContainer = styled.div.withConfig({
  displayName: "Headerstyle__HeaderContainer"
})(["header{background:", ";color:", ";}h1{width:100%;margin-bottom:", ";}[role='banner']{align-self:", ";padding-bottom:", ";}"], ({
  theme
}) => theme.color['fill-surface-raised'], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.space['0'], ({
  isPastMeeting
}) => isPastMeeting ? 'flex-start' : 'center', ({
  isRecurringMeetingExists,
  theme
}) => isRecurringMeetingExists ? theme.space['0'] : theme.space['200']);